import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteUserAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Notify } from '../Utility/Notify';
import { Link } from 'react-router-dom';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import { Delete_All_Comments_For_One_Lead } from '../Redux/Actions/Action_action';
import { useTheme } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Get_All_Leads_Preview_Action } from '../Redux/Actions/MarketingReports_Action';
import { PreviewLeadModal } from '../Pages/PreviewLeadModal';

export const ClientTablee = ({ user, allusers }) => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const dispatch = useDispatch();

  // Modal states
  const [showPreview, setShowPreview] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);

  // delete user state
  const [showdelete, setShowdelete] = useState(false);
  const handleClosedelete = () => setShowdelete(false);
  const handleShowdelete = () => setShowdelete(true);

  // جلب بيانات الـ lead للمعاينة
  const resLeadPreview = useSelector((state) => state.AllMarketingReports.LeadPreview);
  const lead = resLeadPreview?.data;

  const handlePreview = async () => {
    setPreviewLoading(true);
    setShowPreview(true);
    await dispatch(Get_All_Leads_Preview_Action(user._id));
    setPreviewLoading(false);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const deleteuser = async () => {
    await dispatch(
      UpdateClientAction(user?._id, {
        leadisactive: 'false',
      }),
    );
    Notify('success', 'Leads Returned successfully', 'success');
    allusers();
  };

  return (
    <div style={{ paddingBottom: '20px' }}>
      {/* Preview Modal */}
      <PreviewLeadModal
        show={showPreview}
        onHide={handleClosePreview}
        lead={lead}
        loading={previewLoading}
      />

      {/* Delete Modal */}
      <Modal
        style={{ zIndex: 40000 }}
        backdropClassName="custom-backdrop"
        dialogClassName="custom-modal-dialog"
        show={showdelete}
        onHide={handleClosedelete}
      >
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Delete This Client</Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          Are you sure you want to delete this client?
        </Modal.Body>

        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button
            style={{ background: '#fff', color: '#102dff', border: '2px solid #102dff' }}
            onClick={handleClosedelete}
          >
            Close <CancelIcon />
          </Button>
          <Button variant="" style={{ background: '#102dff', color: '#fff' }} onClick={deleteuser}>
            Yes, I am Sure. <DeleteIcon />
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="d-flex justify-content-left">
        {/* update */}
        <Link
          to={`/updateclient/${user._id}`}
          style={{
            textAlign: 'left',
            textDecoration: 'none',
            color: mode === 'dark' ? 'white' : '#666',
          }}
        >
          <ModeEditOutlineOutlinedIcon />
        </Link>

        {/* delete */}
        <DeleteOutlineOutlinedIcon
          onClick={handleShowdelete}
          className="mx-2"
          style={{ color: mode === 'dark' ? 'white' : '#666' }}
        />

        {/* preview - الآن يفتح المودال بدلاً من الانتقال لصفحة جديدة */}
        <RemoveRedEyeOutlinedIcon
          onClick={handlePreview}
          style={{
            cursor: 'pointer',
            color: mode === 'dark' ? 'white' : '#666',
          }}
        />
      </div>
    </div>
  );
};
